import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom"

import { useTranslation } from "react-i18next";

import logo from "../img/logo.png"
import circle from '../img/Home/circle.png'

function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const location = useLocation();

    const { t } = useTranslation();

    return (
        <div>
            <div className="relative z-[999] w-[30px] h-[25px] cursor-poroboto flex flex-col justify-between xl::hidden" onClick={toggleMenu}>
                <div className={`w-full h-[1px] transition duration-300 transform ${isOpen ? 'rotate-45 translate-y-[9px] bg-[#000] w-[35px]' : 'bg-[#000]'}`}></div>
                <div className={`w-full h-[1px] bg-[#000] transition duration-300 transform ${isOpen ? 'hidden' : 'block'}`}></div>
                <div className={`w-full h-[1px]  transition duration-300 transform ${isOpen ? '-rotate-45 -translate-y-[15px] bg-[#000] w-[35px]' : 'bg-[#000]'}`}></div>
            </div>
            <div className={`fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-white z-50 transform transition-all duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <div className="flex flex-col items-center mt-[50px] gap-[15px]">
                    <img src={logo} alt="" className="w-[40px]"/>
                    <Link to="/trading"><p className={`text-[18px] roboto ${location.pathname === '/trading' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.1')}</p></Link>
                    <Link to="/fees"><p className={`text-[18px] roboto ${location.pathname === '/fees' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.2')}</p></Link>
                    <Link to="/accounts"><p className={`text-[18px] roboto ${location.pathname === '/accounts' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.3')}</p></Link>
                    <Link to="/support"><p className={`text-[18px] roboto ${location.pathname === '/support' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.4')}</p></Link>
                    <Link to="/about"><p className={`text-[18px] roboto ${location.pathname === '/about' ? 'font-bold' : 'font-medium'}`} onClick={toggleMenu}>{t('header.5')}</p></Link>
                    <a href="https://user.nine-ventures.net/">
                        <div className="rounded-[80px] px-[20px] p-[5px] flex cursor-pointer items-center gap-[10px] bg-[#0038FF]">
                            <p className="text-white helvetica text-[16px]">{t('home.13')}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;